import React from "react";
import "./styles.scss";
import _ from "lodash";
import FullPageSpinner from "../../../../FullPageSpinner";
import { indexPlaylists } from "../../../../../api/playlists";
import PlaylistSquareTag from "../../../shared/PlaylistSquareTag";
import Pagination from "../../../../shared/Pagination";
import { ReactComponent as NewPlaylistIcon } from "../../../../../public/icons/UserProfile/newPlaylist.svg";
import NewPlaylistModal from "../../../shared/NewPlaylistModal";
import { isSelfId } from "../../../../../api/helper";

export default class Playlists extends React.Component {
  state = {
    playlists: null,
    meta: null,
    page_number: 0,
    page_size: 10,
  };
  componentDidMount() {
    this.indexPlaylists();
  }
  componentDidUpdate(prevProp, prevState) {
    if (
      prevState.page_number !== this.state.page_number ||
      prevState.page_size !== this.state.page_size
    )
      this.indexPlaylists();
  }
  indexPlaylists = async () => {
    this.setState({ playlists: null });
    let {
      data: { playlists, meta },
    } = await indexPlaylists({
      page_number: this.state.page_number,
      page_size: this.state.page_size,
      filter: { user_id: this.props.user.id, is_rss: false },
    });
    this.setState({ playlists, meta });
  };
  changePage = page_number => this.setState({ page_number });
  changePageSize = page_size => this.setState({ page_size });
  playlistSetter = newPlaylist =>
    this.setState({
      playlists: this.state.playlists.map(playlist =>
        playlist.id === newPlaylist.id ? newPlaylist : playlist
      ),
    });
  render() {
    return (
      <div className="profile-playlists m-4">
        {_.isNull(this.state.playlists) ? (
          <FullPageSpinner className="my-5" />
        ) : (
          <div className="profile-grid-view">
            {this.state.playlists.map(playlist => (
              <PlaylistSquareTag
                key={playlist.id}
                playlist={playlist}
                playlistSetter={this.playlistSetter}
              />
            ))}
          </div>
        )}
        {isSelfId(this.props.user.id) && (
          <NewPlaylistModal>
            <h2 className="text-uppercase text-center text-dark my-5 d-none d-md-block">
              New Playlist <NewPlaylistIcon />
            </h2>
          </NewPlaylistModal>
        )}
        <Pagination
          meta={this.state.meta}
          page={this.state.page_number}
          pageSize={this.state.page_size}
          changePage={this.changePage}
          changePageSize={this.changePageSize}
        />
      </div>
    );
  }
}
